import { signOut } from "firebase/auth";
import auth from "./firebase";

let logout = () => {
  signOut(auth)
    .then((userCredential) => {
      const user = userCredential.user;
      localStorage.removeItem("avEcoAccessToken");
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
    });
};

export { logout };
